module.exports = __webpack_public_path__ + "static/media/road.c3a83122.jpg";